import { managementMenu } from './management';
import { billMenu } from './bill';
import { attendanceMenu } from './attendance';
import { postMenu } from './post';
import { homeworkAndScheduleMenu } from './homeworkAndSchedule';
import { reportMenu } from './report';
import { counselMenu } from './counsel';
import { messageMenu } from './message';
import { settingMenu } from './setting';
import { etcMenu } from './etc';
import { textbookMenu } from './textbook';

const pcMenu = {
  managementMenu,
  textbookMenu,
  billMenu,
  attendanceMenu,
  postMenu,
  homeworkAndScheduleMenu,
  reportMenu,
  counselMenu,
  messageMenu,
  settingMenu,
  etcMenu,
};

export default pcMenu;
